import { MQAPage } from "@/features/entryscape/mqa-page";

export default MQAPage;
